import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAll(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/HSConversations/get?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSConversations/getsingle?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingleReadOnly(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSConversations/GetDetailReadyOnly?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchImage(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSConversations/getimage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSConversations/delete?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    deleteImage(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSConversations/deleteImage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(conversation) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSConversations/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: conversation
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(conversation) {

        const options = {
            method: 'put',
            url: `/umbraco/api/HSConversations/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: conversation
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    uploadImage(image, conversationId) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSConversations/UploadImage?id=${conversationId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }

}